


import React from 'react'
import './Camps.css'



const Camps:React.FC = () => {



  return (
    <div className=' w-screen overflow-hidden p-10 custom-athletic-container '>

    <div className=' flex flex-col items-center justify-center mx-auto max-w-[800px]'>
        <div className='sm:text-lg md:text-xl lg:text-3xl xl:text-4xl text-black font-sans '>
            <h3>Athletic Training Camps</h3>
            </div>

            <div className=' sm:text-lg mg:text-lg lg:text-xl xl:text-xl  text-black text-center font-mono w-[80%] mt-10'>
                <p>Our camps provide elite-level training with a focus on fundamentals,
                     performance, and exposure. Featuring NFL trainers and experienced staff.</p>
            </div>

    </div>

    
</div>





  )
}




export default Camps
